enum TransactionDetailsMoneyInOutIndicator {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
}

export default TransactionDetailsMoneyInOutIndicator;
